import { render, staticRenderFns } from "./SubBackupDetail.vue?vue&type=template&id=3b391173&"
import script from "./SubBackupDetail.vue?vue&type=script&lang=js&"
export * from "./SubBackupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports